export default  {

    /**
     * Logo
     */
     logo:require('./images/logo1.png'),

     /**
      * 默认头像1
      */
     default_avatar_1:require('./images/default-avatar-1.png'),

     /**
      * 电话
      */
     tel:require('./images/tel.png'),

     /**
      * 邮箱
      */
     email:require('./images/email.png'),

     /**
      * 微信
      */
     wechat:require('./images/wechat.png'),

     /**
      * 登录背景
      */
     login_background:require("./images/login_background.png")

}